import { InvoiceStatus } from '@admiin-com/ds-graphql';
import { WBToggleButtonGroup } from '@admiin-com/ds-web';
import { styled, ToggleButton } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { TASK_FORM_FIELDS } from '../../../helpers/form';

interface Props {
  isDraft?: boolean;
}

export const InvoiceType = ({ isDraft }: Props) => {
  const { t } = useTranslation();
  const methods = useFormContext();

  const inputs = React.useMemo(
    () => ({
      invoiceStatus: {
        ...TASK_FORM_FIELDS.invoiceStatus,
      },
    }),
    []
  );

  return (
    <Controller
      name={inputs.invoiceStatus.name}
      control={methods.control}
      defaultValue={inputs.invoiceStatus.defaultValue}
      render={({ field }) => (
        <WBToggleButtonGroup
          {...field}
          size="medium"
          exclusive
          disabled={isDraft}
        >
          {Object.keys(InvoiceStatus).map((key) => {
            return (
              <StyledRectToggleButton value={key} key={key} disabled={isDraft}>
                {t(key, { ns: 'taskbox' })}
              </StyledRectToggleButton>
            );
          })}
        </WBToggleButtonGroup>
      )}
    />
  );
};

export const StyledRectToggleButton = styled(ToggleButton)(({ theme }) => ({
  borderColor: theme.palette.primary.main,
  fontWeight: 500,
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },
  padding: theme.spacing(1.5, 3),
}));
